export const HOME_ROUTE = "/";

export const BUSHA_ROOT = "/busha";

export const BUSHA_LOGIN_PAGE = "busha-login";

export const BUSHA_ASSETS_PAGE = "busha-assets";

export const BUSHA_TEST_ASSETS_PAGE = "busha-test-assets";

export const BUSHA_TRANSFER_CONFIRM_PAGE = "busha-transfer-confirm";

export const TRANSFER_ROOT = "/transfer";

export const ASSETS_SELECTION_PAGE = "assets";

export const PAYMENT_PAGE = "payment";

export const PAYMENT_METHOD_ROUTE = "/payment-method";